/* Delfino — product-offers („Oferte (produs)", 01.10.2026). Omul alege oferta în treptele de mai jos
   din pagină → cantitatea ajunge în formularul de produs din erou (`form.shopify-product-form`
   [name="quantity"]), de unde aplicația Releasit o citește când deschide pop-up-ul, și emitem
   `dl:bundle-changed` pe document — evenimentul pe care îl ascultă sincronizarea din product.js
   (bindOfferSync bifează aceeași ofertă în pop-up). Nu atinge formularul Releasit.
   Același idiom ca section-comparison-table.js: DL.use, idempotent (data-bound). */
(function () {
  'use strict';

  function toInt(v, d) {
    var n = parseInt(v, 10);
    return isNaN(n) ? d : n;
  }

  function choose(box, row) {
    var qty = toInt(row.getAttribute('data-qb-qty'), 1);
    var rows = box.querySelectorAll('.dl-qb-row');
    for (var i = 0; i < rows.length; i++) {
      var on = rows[i] === row;
      rows[i].classList.toggle('is-active', on);
      rows[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
    var inputs = document.querySelectorAll('form.shopify-product-form input[name="quantity"]');
    for (var j = 0; j < inputs.length; j++) inputs[j].value = String(qty);
    var total = toInt(row.getAttribute('data-qb-total'), 0);
    var was = toInt(row.getAttribute('data-qb-was'), 0);
    try {
      document.dispatchEvent(new CustomEvent('dl:bundle-changed', {
        detail: { qty: qty, total: total, was: was > total ? was : null, perUnit: toInt(row.getAttribute('data-qb-perunit'), 0) }
      }));
    } catch (e) { /* browser fără CustomEvent — cantitatea e oricum în formular */ }
  }

  function bind(root) {
    var boxes = (root || document).querySelectorAll('[data-dl-offers]:not([data-bound])');
    for (var i = 0; i < boxes.length; i++) {
      (function (box) {
        box.dataset.bound = '1';
        box.addEventListener('click', function (e) {
          var row = e.target && e.target.closest ? e.target.closest('.dl-qb-row') : null;
          if (row && box.contains(row)) choose(box, row);
        });
      })(boxes[i]);
    }
  }

  function register() {
    if (window.DL && typeof window.DL.use === 'function') window.DL.use(bind);
    else bind(document);
  }
  if (window.DL && typeof window.DL.use === 'function') register();
  else document.addEventListener('DOMContentLoaded', register);
})();
